// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"354":"1ab67623573e78d51207","5524":"d0680e120a2bce290d24","6394":"bcd876e44d0f816c7f5b","7675":"2ab4c0a59899c18ff4c1"}[chunkId] + ".js";
};